import { CROP_CONFIG } from './cropConfig';
/**
 * Shared constants for Family Tree Canvases
 */

export const NODE_WIDTH = 180;
export const NODE_HEIGHT = 110;
export const NODE_SHAPE = 'round-rectangle';

export const SHARED_NODE_STYLE: any = {
  'shape': NODE_SHAPE,
  'width': NODE_WIDTH,
  'height': NODE_HEIGHT,
  'label': 'data(label)',
  'text-wrap': 'wrap',
  'text-max-width': 170,
  'font-size': '12px',
  'text-valign': 'bottom',
  'text-halign': 'center',
  'text-margin-y': 12,
  'background-image': 'data(photoUrl)',
  'background-fit': 'cover',
  'border-width': 2,
  'border-color': '#E0E0E0',
  'corner-radius': CROP_CONFIG.NODE_BORDER_RADIUS,
};

export const SHARED_EDGE_STYLE: any = {
  'curve-style': 'bezier',
  'width': 3,
  'line-color': '#999',
  'target-arrow-color': '#999',
  'target-arrow-shape': 'triangle',
};